import { useIsMobile, useIsTouch } from '@/hooks/useIsMobile';

/**
 * Provider that initializes and manages the centralized mobile state
 * Should be wrapped around the app to ensure mobile state is available everywhere
 */
export function DeviceProvider({ children }: { children: React.ReactNode }) {
  // This hook initializes and maintains the mobile state in the UI store
  useIsMobile();
  useIsTouch();

  return <>{children}</>;
}
